import * as types from '../mutation-types';
import api from '../../helpers/api';


export default {
  state: {
    all: [],
  },
  getters: {
    getArticles: (state) => state.all,
    getNews: (state) => state.all.filter((article) => article.category.id === 8),
    getOffers: (state) => state.all.filter((article) => article.category.id === 12),
    getProducts: (state) => state.all.filter((article) => article.category.id === 2),
  },
  actions: {
    async getAllArticles({ commit }) {
      const articles = await api.get('articles/active');

      if (typeof articles !== 'undefined') {
        articles.forEach((article) => {
          const articlePrepared = article;
          if (articlePrepared.image) return;
          if (articlePrepared.titleimage) {
            articlePrepared.image = articlePrepared.titleimage;
          } else if (articlePrepared.images) {
            [articlePrepared.image] = articlePrepared.images;
          }
        });
      }

      commit(types.RECEIVED_ARTICLES, { articles });
    },
  },
  mutations: {
    [types.RECEIVED_ARTICLES](state, { articles }) {
      state.all = articles;
    },
  },
};
